<template>
  <div
    id="content"
    class="d-flex"
  >
    <component
      :is="layout"
      v-if="$auth.ready()"
    >
      <router-view :key="$route.fullPath" />
    </component>

    <vue-progress-bar />
  </div>
</template>

<script>
export default {
  computed: {
    layout () {
      const layout = `${this.$route.meta.layout || 'default'}`
      return () => import( `@/layouts/${layout}`)
    }
  }
}
</script>

<style lang="scss" scoped>
#content {
  min-height: 100vh;
}
</style>
